import React from 'react';
import {
  Box,
} from '@mui/material';
import { GroundTruthSingleChoiceWithText, QuestionSingleChoiceWithText } from '../../redux/types';

type Props = {
  payload: GroundTruthSingleChoiceWithText['payload'];
  question: QuestionSingleChoiceWithText;
};

const GTSingleChoiceWithTextScore: React.FC<Props> = ({
  question,
  payload,
}: Props) => (
  <Box sx={{ whiteSpace: 'pre-wrap' }}>
    {
      question.payload?.filter((op) => {
        const { score } = payload[op.id] || {};
        return !!score;
      })
        .map((op) => (`${op.text} (${payload[op.id].score})`))
        .map((t) => (
          <Box key={t}>
            {t}
          </Box>
        ))
    }
  </Box>
);

export default GTSingleChoiceWithTextScore;
